import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ModalComponent } from '../common/modal/modal.component';
import { SliderComponent } from '../common/slider/slider.component';

@NgModule({
    declarations: [ModalComponent],
    imports: [CommonModule, DialogModule,SliderComponent],
    exports: [ModalComponent, SliderComponent],
})
export class SharedModule { }
